import './theme/tokens.scss';
import './theme/typography.scss';
import './theme/global.scss';
import './legacy/edit-links.scss';
import './legacy/aoc-accordion.scss';
import './legacy/aoc-sidenav.scss';
import './legacy/aoc-slider.scss';
import './legacy/aoc-subpage-banner.scss';
import './legacy/aoc-pub-mobile-search.scss';
import './legacy/aoc-pub-image-slider.scss';
import './widgets/aoc-category-list-facet';
import './widgets/aoc-category-tree-facet';
import './widgets/aoc-search-results';
import './fragments/layouts/aoc-1-2-layout';
import './fragments/layouts/aoc-1-3-layout';
import './fragments/layouts/aoc-1-70-30-layout';
import './fragments/layouts/aoc-2-3-layout';
import './fragments/layouts/aoc-2-70-30-layout';
import './fragments/layouts/aoc-search-layout';
import './fragments/layouts/aoc-sticky-side-nav';
import './fragments/util/npt-collection-config';
import './fragments/util/npt-conditional-content';
import './fragments/util/npt-segmented-content';
import { onReady } from './utils';
onReady(() => {
  console.log('NeptuneUI ready');
});
if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
}